export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13232.29d33360.jpg";